export interface Country {
  code: string;
  key: string;
  name: string;
  operator: string;
  flagCode: string;
  path: string;
}

export const countries: Country[] = [
  {
    code: 'AT',
    key: 'austria',
    name: 'Austria',
    operator: 'ASFINAG',
    flagCode: 'at',
    path: '/austria',
  },
  {
    code: 'HU',
    key: 'hungary',
    name: 'Hungary',
    operator: 'Nemzeti Útdíj',
    flagCode: 'hu',
    path: '/hungary',
  },
  {
    code: 'CH',
    key: 'switzerland',
    name: 'Switzerland',
    operator: 'Via Admin',
    flagCode: 'ch',
    path: '/switzerland',
  },
  {
    code: 'CZ',
    key: 'czechRepublic',
    name: 'Czech Republic',
    operator: 'SFDI',
    flagCode: 'cz',
    path: '/czechia',
  },
  {
    code: 'SK',
    key: 'slovakia',
    name: 'Slovakia',
    operator: 'NDS',
    flagCode: 'sk',
    path: '/slovakia',
  },
  {
    code: 'SI',
    key: 'slovenia',
    name: 'Slovenia',
    operator: 'DARS',
    flagCode: 'si',
    path: '/slovenia',
  },
  {
    code: 'RO',
    key: 'romania',
    name: 'Romania',
    operator: 'CNAIR',
    flagCode: 'ro',
    path: '/romania',
  },
  {
    code: 'BG',
    key: 'bulgaria',
    name: 'Bulgaria',
    operator: 'BGtoll',
    flagCode: 'bg',
    path: '/bulgaria',
  },
];
